import React, { useEffect, useMemo, useState } from "react";
import { Grid, Box, Button, Typography, Alert, TextField, Select, MenuItem } from "@mui/material";
import { PlayArrow, Pause, Edit, Check } from "@mui/icons-material";
import { useMatchTimer } from "../../../../hooks/useMatchTimer.js";
import { getAllMatchPeriods, getPlayedGamesPeriods } from "../../../../sports/rules.js";
import { useDirect, useMatch } from "../DirectContext.js";
import { useDispatch } from "react-redux";
import { updateMatch } from "../../../../../actions/matchs.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPause, faPlay, faStop } from "@fortawesome/free-solid-svg-icons";
import DsasButton from "../../../../components/DsasButton/DsasButton.js";
import styles from "./Chrono.module.css"

//fonction utilitaire, a bouger dans un hook plus propre ensuite
const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const checkTouch = () =>
      setIsTouch("ontouchstart" in window || navigator.maxTouchPoints > 0);
    checkTouch();
  }, []);

  return isTouch;
};

/**
 * ChronoEditable is a React component that manages the display and editing of a match timer (chronometer) 
 * for a sports match. It allows users to view the current timer, edit the timer and period, and control 
 * the timer's running state (start/pause). The component switches between display and edit modes, 
 * providing validation and error handling for timer values.
 *
 * @component
 * @param {Object} props
 * @param {Function} props.handleEventClick - Callback function to handle event button clicks in the timer UI.
 *
 * @returns {JSX.Element} The rendered ChronoEditable component, which includes the timer display, 
 * editing controls, and period selection.
 *
 * @example
 * <ChronoEditable handleEventClick={myEventHandler} />
 */
const Chrono = ({ onEdit, handleEventClick }) => {

  const [isHovered, setIsHovered] = useState(false);

  const { changeStatusTimer, getPeriodAction, timer, isRunning, timeOffset, getCurrentMatchPeriodName, isTimerLocked } = useMatchTimer();

  const match = useDirect()

const isTouchDevice = useIsTouchDevice();

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const periodAction = useMemo(() => {
    return getPeriodAction(handleEventClick)
  }, [getPeriodAction, handleEventClick])

  return (
    <Grid container>
      <Grid item xs={6} md={6} lg={6} textAlign={"center"} alignContent={"center"}>
        {/*PERIOD BUTTON ACTION*/}
        {periodAction}
      </Grid>
      {/* TODO {"-webkit-center"} change to {"-center"} */}
      <Grid item xs={6} md={6} lg={6} p={1} textAlign={"-webkit-center"} alignContent={"center"}>

        {/*CHRONO PART*/}
        <Box>

          {/*TIMER & EDIT TIMER BUTTON WRAPPER*/}
          <Box className={styles.chronoWrapper}>
            {/*TIMER*/}
            <Box 
              sx={{   
              backgroundColor: 'var(--color-light-grey)',
              padding: '10px',
              color: 'var(--color-dark-grey)',
              height: '20px',
              width: '62px',
              visibility: match.discipline === 'basket' ? 'hidden' : 'visible'
              }}>
              <Typography variant="h4" sx={{ fontWeight: "bold", fontStyle:'normal' }}>
              {/* {match.status === 'end' ? "Match terminé" : formatTime(timer+timeOffset)} */}
              {formatTime(timer+timeOffset)}
              </Typography>
            </Box>
            {/*TIMER & EDIT TIMER BUTTON*/}
            <Box className={styles.editChronoBtn}>
            <DsasButton 
              label={match.discipline === 'basket' ? "Editer le quart-temps" :"Editer le chrono"  }
              icon={faEdit} 
              onClick={onEdit} 
              variant = 'secondary' 
              customCss={{margin:0, fontSize: '14px', height: '30px'}} 
              />
              </Box>
          </Box>

          {/*PERIOD NAME & PLAY BUTTON*/}
          {/*MATCH STATUS == END*/}
          {match.status === 'end' && <Box
              className='display-column fit-content-wrapper bordered-wrapper small-rounded-wrapper'
              sx={{padding:0}}
            >
              <Box className='small-padding-wrapper'></Box>
              <Typography sx={{color:'var(--color-dark-grey)', fontSize: '14px', padding:'8px'}}><i>Match terminé</i></Typography>

              <Box className={styles.statusTimerBtnOff}>
                {/*STOP BUTTON*/}
                <Button
                  disabled
                  sx={{
                    width:'100%',
                    borderRadius:'0',
                  // backgroundColor: "var(--color-light-grey)",
                  "&.Mui-disabled": {
                    opacity: 1,
                    // backgroundColor: "var(--color-light-grey)",
                    color: "inherit",
                    cursor: "not-allowed",
                  },}}
                >
                  <FontAwesomeIcon
                      icon={faStop }
                          style={{ color: 'var(--color-light-grey)', fontSize: 'x-large' }}
                                          />
                </Button>
              </Box>
            </Box>
          } 

          {/*PERIOD NAME & PLAY BUTTON*/}
          {/*MATCH STATUS != END*/}
          {match.status !== 'end' && <Box
            className={`display-column fit-content-wrapper bordered-wrapper small-rounded-wrapper' ${isRunning ? styles.borderedChronoOn : styles.borderedChronoOff}`}
            sx={{padding:0}}
          >
            <Box className='small-padding-wrapper'></Box>
            <Typography sx={{color:'var(--color-dark-grey)', fontSize: '14px', padding:'8px'}}><i>{getCurrentMatchPeriodName()}</i></Typography>
            {match.discipline !== 'basket' && 
            <Box className={
                isTimerLocked 
                  ? styles.statusTimerBtnOff 
                  : (isRunning ? styles.statusTimerBtnOn : styles.statusTimerBtnOff)
              }>
              {/*PLAY STOP BUTTON*/}
              <Button
                disabled={timer === 0 || isTimerLocked}
                onMouseEnter={() => !isTouchDevice && setIsHovered(true)}
                onMouseLeave={() => !isTouchDevice && setIsHovered(false)}
                onClick={(e) => {
                  changeStatusTimer();
                  // Si mobile, on force la sortie du hover après clic
                  if (isTouchDevice) setIsHovered(false);
                }}
                sx={{
                  width:'100%',
                  borderRadius:'0',
                // backgroundColor: "var(--color-light-grey)",
                "&.Mui-disabled": {
                  opacity: 1,
                  // backgroundColor: "var(--color-light-grey)",
                  color: "inherit",
                  cursor: "not-allowed",
                },}}
              >
                <FontAwesomeIcon
                    icon={
                        isHovered
                          ? (isRunning ? faPause : faPlay)
                          : (isRunning ? faPlay : faPause)
                      }
                      style={{ color: 'var(--color-light-grey)', fontSize: 'x-large' }}
                                        />
              </Button>
            </Box>}

          </Box>}
        </Box>
      </Grid>
      {/* <Grid item xs="2"></Grid> */}
    </Grid>
  );
};

const ChronoEdit = ({ onSave, onCancel, initialTimer, initialPeriod }) => {
  const match = useDirect();

  const [period, setPeriod] = useState(initialPeriod);

  // console.log('period in ChronoEdit : ', period)

  
      //TODO utiliser celui de rules.js
      function getPeriodPlayedModel(discipline, matchPeriod) {
          const allPeriods = getPlayedGamesPeriods(discipline);
          const periodModel = [...allPeriods.values()]
              .find(p => p.matchPeriod === matchPeriod);
  
          return periodModel;
          }
  //TODO utiliser celui de rules.js
      function getPeriodModel(discipline, matchPeriod) {
          const allPeriods = getAllMatchPeriods(discipline);
          const periodModel = [...allPeriods.values()]
              .find(p => p.matchPeriod === matchPeriod);
  
          return periodModel;
          }

  // Calcul du timerOffset basé sur la période sélectionnée
const timerOffset = useMemo(() => {
    if (period === -1) return 0;

    // sécurité : la discipline DOIT être connue
    if (!match?.discipline) return 0;
 // On s’aligne sur la même logique que pour les stats / temps de jeu
    //ici il faut récupérer les periodes jouables et ensuite récupérer le minDuration de la periode actuelle
    let currentPeriod = getPeriodPlayedModel(match.discipline, period);
    if (!currentPeriod){
        currentPeriod = getPeriodModel(match.discipline, period);
        //TODO OPTA PER 2 - bout de scotch là
                if (!currentPeriod){
                    currentPeriod = getPeriodModel(match.discipline, 6);
                }
    }

    // console.log('end ici 2')
    const baseMinutes = currentPeriod?.minDuration || 0;

    // const baseMinutes = getMinTotalDuration(match.period, match.discipline);
    return baseMinutes * 60;

}, [period, match.discipline]);

  // État du timer + gestion du message d'erreur
  const [timer, setTimer] = useState(initialTimer + timerOffset);
  const [error, setError] = useState(""); // ✅ Gère l'erreur

  // 🔢 Formattage du temps en MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  useEffect(() => {
    // On défini le timer sur le minimum
    if(timer < timerOffset)
      setTimer(timerOffset)

  }, [period])

  // Liste des périodes
  const allPeriods = getAllMatchPeriods(match.discipline);
  const periodEntries = [...allPeriods.entries()];
  const lastPeriod = periodEntries[periodEntries.length - 1];

  // On garde uniquement les périodes jouables + la dernière
  const periodToDisplay = periodEntries.filter(([key, period]) => period.isPlayable);
  if (lastPeriod && !periodToDisplay.includes(lastPeriod)) {
    periodToDisplay.push(lastPeriod);
  }

  const periodSelectionChanged = (e) => {
    if (e.target.value === -1) {
              setPeriod(-1);
              setTimer(0);
            } else {
              if (match?.discipline === 'basket'){
                // Pour le basket, on ajuste le timer pour qu'il soit à 0 au début du quart-temps
                setTimer(0);
              } 
              setPeriod(e.target.value);
            }
  }

  return (
    <Grid container spacing={2} justifyContent="center">
       {match.discipline !== 'basket' && <Grid item xs={12} textAlign="center">
      {/* {<Grid item xs={12} textAlign="center"> */}
        <TextField
          label="Minutes"
          type="number"
          value={Math.floor(timer / 60)} // Convertit secondes → minutes
          onChange={(e) => {
            const minutes = Math.max(0, parseInt(e.target.value) || 0);
            const newTimer = minutes * 60 + (timer % 60);

            // Vérification de l'erreur
            if (minutes < (timerOffset/60)) {
              setError(`Minimum : ${formatTime(timerOffset)}`);
            } else {
              setError(""); // ✅ Supprime l'erreur si tout est OK
            }

            setTimer(newTimer);
          }}
          sx={{ width: "80px", marginRight: "8px" }}
          error={!!error} // Active le style d'erreur si `error` n'est pas vide
          helperText={error} // Affiche le message d'erreur sous le champ
        />

        <TextField
          label="Secondes"
          type="number"
          value={timer % 60} // Récupère les secondes
          onChange={(e) => {
            const seconds = Math.max(0, Math.min(59, parseInt(e.target.value) || 0)); // Bloque entre 0 et 59
            setTimer(Math.floor(timer / 60) * 60 + seconds); // Garde les minutes inchangées
          }}
          sx={{ width: "80px" }}
        />
      </Grid>}

{/*Only for basketball set minute info in Typography mui text*/}
      {match.discipline === 'basket' && (<Grid item xs={12} textAlign="center">
        <Typography>
         {Math.floor(timer / 60)}'
        </Typography>
      </Grid>)}

      {/* 🔄 Sélection de la période */}
      <Grid item xs={12} textAlign="center">
        <Select
          value={period}
          onChange={(e) => periodSelectionChanged(e)}
        >
          <MenuItem key={-1} value={-1}>
            Match non démarré
          </MenuItem>
          {periodToDisplay.map(([key, period]) => (
            <MenuItem key={key} value={period.matchPeriod}>
              {period.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>

      {/* ✅ Boutons avec désactivation si erreur */}
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          color="success"
          onClick={() => onSave({ timer: timer - timerOffset, period: Math.max(0, period) })}
          disabled={!!error} // ✅ Désactive le bouton si une erreur est présente
        >
          <Check /> Valider
        </Button>
        <Button variant="outlined" color="error" onClick={onCancel} sx={{ ml: 1 }}>
          Annuler
        </Button>
      </Grid>
    </Grid>
  );
};

const ChronoEditable = ({handleEventClick}) => {

  const { timer, period, updateMatchChrono, isRunning, changeStatusTimer } = useMatchTimer();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Grid item xs={12} textAlign={"center"}>
      {isEditing ? (
        <ChronoEdit
          initialTimer={timer}
          initialPeriod={period}
          onSave={({ timer, period }) => {
            updateMatchChrono({ timer, period })

            setIsEditing(false)
          }}
          onCancel={() => setIsEditing(false)}
        />
      ) : (
        <Chrono onEdit={() => {
          if(isRunning)
            changeStatusTimer() 
          setIsEditing(true)}} 

          handleEventClick={handleEventClick}
          
        />
      )}
    </Grid>
  );
};

export default ChronoEditable;
